<template>
<!-- Main Content Area -->
<div class="configVue">
    <!-- Main Body Content area -->
        <div class="o-main-content-area">
            <!-- Heading Section -->
            <div class="o-page-top-heading c-responsive-fixwidth">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="h1">Configuration:</h1>
                    </div>
                </div>
            </div>
            <!-- /Heading Section -->
        </div>
        <!-- /Main Body Content area -->

        <!-- Individual calls section area -->

        <div class="o-ndividualArea c-responsive-fixwidth">

            <div class="o-ndividualTable c-config-design">
                <div class="c-common-space o-individual-calls">
                    <div class="col-sm-3 skillset o-no-padding">
                        <h5 class="c-common-heading"><span class="c-common-btn--inverse-icon-orange"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></span> Administrator Options</h5>
                    </div>
                </div>
                <div class="clearfix">
                    <div class="col-md-2 c-common-box-shadow">
                        <!-- <ul>
                            <li><a href="javascript: void(0)"></a></li>
                        </ul> -->
                        <div class="row">
                            <ul class="o-sidebar-menu-inner o-config-sidenav">
                            <li><a href="javascript: void(0)" :class="{'config-active':(this.tab=='ownerOption')?true:false}" @click="changeTab('ownerOption')">Owner Options</a></li>
                            <li><a href="javascript: void(0)" :class="{'config-active':(this.tab=='managePUser')?true:false}" @click="changeTab('managePUser')">Manage Powerusers</a></li>
                            <li><a href="javascript: void(0)" :class="{'config-active':(this.tab=='manageDriveAdmin')?true:false}" @click="changeTab('manageDriveAdmin')">Manage Drive Admins</a></li>
                            <li><a href="javascript: void(0)" :class="{'config-active':(this.tab=='manageAuditor')?true:false}" @click="changeTab('manageAuditor')">Manage Auditor</a></li>
                            <li><a href="javascript: void(0)" :class="{'config-active':(this.tab=='statusLevel')?true:false}" @click="changeTab('statusLevel')">Status Levels</a></li>
                            <li><a href="javascript: void(0)" :class="{'config-active':(this.tab=='penaltyRules')?true:false}" @click="changeTab('penaltyRules')">Penalty Rules</a></li>
                            <!-- <li><a :class="{'config-active':(this.tab=='fileRepo')?true:false}" @click="changeTab('fileRepo')">File Repository</a></li> -->
                            <li><a href="javascript: void(0)" :class="{'config-active':(this.tab=='batchAuth')?true:false}" @click="changeTab('batchAuth')">Batch Authorize</a></li>
                            <li><a href="javascript: void(0)" :class="{'config-active':(this.tab=='adminLock')?true:false}" @click="changeTab('adminLock')">Admin Lock</a></li>
                            <li><a href="javascript: void(0)" :class="{'config-active':(this.tab=='onboarding')?true:false}" @click="changeTab('onboarding')">Onboarding</a></li>
                            <li><a href="javascript: void(0)" :class="{'config-active':(this.tab=='driveBackup')?true:false}" @click="changeTab('driveBackup')">Drive Backup</a></li>
                            <!-- #1737 — Contact info. Data-only: officer contacts +
                                 an OK-to-forward-calls permission. Reached only from
                                 /configuration, which is CA/SA-gated by the route
                                 allowlist; the API is gated again server-side (#1686). -->
                            <li><a href="javascript: void(0)" :class="{'config-active':(this.tab=='contactInfo')?true:false}" @click="changeTab('contactInfo')">Contact info</a></li>

                            <!-- #1781 — Assign page colours. SCAFFOLD: stores a
                                 per-client colour for each of the twelve
                                 availability statuses. Nothing on the assign page
                                 reads them yet, so this tab is a visual no-op by
                                 design. Same CA/SA gating as Contact info — the
                                 /configuration route allowlist plus a server-side
                                 role check in the controller (#1686). -->
                            <li><a href="javascript: void(0)" :class="{'config-active':(this.tab=='statusColors')?true:false}" @click="changeTab('statusColors')">Assign page colours</a></li>

                            <!-- #1797 — Payroll Steward: the approver identity, and a
                                 billable seat. CA/SA only, gated by the /configuration
                                 route allowlist plus a server-side role check on write
                                 (#1686). Read is open; only writes are CA/SA. -->
                            <li><a href="javascript: void(0)" :class="{'config-active':(this.tab=='payrollSteward')?true:false}" @click="changeTab('payrollSteward')">Payroll Steward</a></li>

                            <!-- #2091 — Chat. PREVIEW ONLY: behind CHAT_UI_PREVIEW
                                 (src/chatPreview.js), which is off unless a build
                                 explicitly set it, so this item does not exist in a
                                 normal build. Client Admin and CS staff only, which
                                 is checked here AND is the whole gate — there is no
                                 server side to this yet because there is no chat
                                 back end to call. -->
                            <li v-if="chatPreviewVisible"><a href="javascript: void(0)" data-testid="config-chat-item" :class="{'config-active':(this.tab=='chat')?true:false}" @click="changeTab('chat')">Chat</a></li>

                            <!-- <li><a href="#" data-content="">Owner Options</a></li>
                            <li><a href="#">Manage Powerusers</a></li>
                            <li><a href="#">Status Levels</a></li>
                            <li><a href="#">File Repository</a></li>
                            <li><a href="#">Batch Authorize</a></li> -->


                            </ul>
                        </div>

                    </div>
                    
                    <configOwnerOption :empDetails="detailEmployee" v-if="this.tab == 'ownerOption'"/>
                    <configManageUser :empDetails="detailEmployee" v-if="this.tab == 'managePUser'"/>
                    <configManageDriveAdmin :empDetails="detailEmployee" v-if="this.tab == 'manageDriveAdmin'"/>
                    <configManageAuditor :empDetails="detailEmployee" v-if="this.tab == 'manageAuditor'"/>
                    <configStatusLevel :empDetails="detailEmployee" v-if="this.tab == 'statusLevel'"/>

                    <configPenaltyRules :empDetails="detailEmployee" v-if="this.tab == 'penaltyRules'" />
                    <!-- <configFileRepo :empDetails="detailEmployee" v-if="this.tab == 'fileRepo'"/> -->
                    <configBatchAuth :empDetails="detailEmployee" v-if="this.tab == 'batchAuth'"/>
                    <adminLock :empDetails="detailEmployee" v-if="this.tab == 'adminLock'"/>
                    <configOnboarding :empDetails="detailEmployee" v-if="this.tab == 'onboarding'"/>
                    <configDriveBackup :empDetails="detailEmployee" v-if="this.tab == 'driveBackup'"/>
                    <configContactInfo :empDetails="detailEmployee" v-if="this.tab == 'contactInfo'"/>
                    <configStatusColors :empDetails="detailEmployee" v-if="this.tab == 'statusColors'"/>
                    <configPayrollSteward :empDetails="detailEmployee" v-if="this.tab == 'payrollSteward'"/>
                    <configChat :empDetails="detailEmployee" v-if="chatPreviewVisible && this.tab == 'chat'"/>
                    
                </div>

            </div>
        </div>

        <!-- /Individual calls section area -->   
</div>
<!-- /Main Content Area -->
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import { global } from '../../global.js';
    import { bus } from '../../main';
    import configOwnerOption from './configOwnerOption';
    import configChat from './configChat';                       // #2091, preview only
    import { chatUiEnabled, canAdminChat } from '../../chatPreview.js';
    import configManageUser from './configManageUser';
    import configManageAuditor from './configManageAuditor';
    import configManageDriveAdmin from './configManageDriveAdmin';
    import configStatusLevel from './configStatusLevel';
    import configPenaltyRules from './configPenaltyRules';
    //    import configFileRepo from './configFileRepo';
    import configBatchAuth from './configBatchAuth';
    import adminLock from './adminLock';
    import configOnboarding from './configOnboarding';
    import configDriveBackup from './configDriveBackup';
    import configContactInfo from './configContactInfo'; // #1737
    import configStatusColors from './configStatusColors'; // #1781
    import configPayrollSteward from './configPayrollSteward'; // #1797
    export default {
        computed: {

            /**
             * #2091 — the Chat item exists only when the build asked for the preview
             * AND the signed-in person administers chat.
             *
             * Both halves matter. The flag keeps an unfinished screen out of a normal
             * build; the role keeps it out of a Power User's or Steward's menu on the
             * one environment where the flag IS on. Neither is a substitute for the
             * other.
             */
            chatPreviewVisible() {
                return chatUiEnabled() && canAdminChat(this.userRoleSlug);
            },
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userRoleSlug: 'userRoleSlug',   // #2091 — gates the Chat item
                userClientID: 'userClientID',
                currentEmployeeID: 'currentEmployeeID'
            })
        },
        components: {
            'configOwnerOption': configOwnerOption,
            'configManageUser': configManageUser,
            'configManageAuditor': configManageAuditor,
            'configManageDriveAdmin': configManageDriveAdmin,
            'configStatusLevel': configStatusLevel,
            'configPenaltyRules': configPenaltyRules,
            //            'configFileRepo': configFileRepo,
            'configBatchAuth': configBatchAuth,
            'adminLock': adminLock,
            'configOnboarding': configOnboarding,
            'configDriveBackup': configDriveBackup,
            'configContactInfo': configContactInfo, // #1737
            'configStatusColors': configStatusColors, // #1781
            'configPayrollSteward': configPayrollSteward, // #1797
            'configChat': configChat, // #2091, preview only
        },
        data() {
            return {
                tab: "ownerOption",
                detailEmployee: {},
                getBaseURL: '',
            }
        },
        methods: {
            changeTab(newTab) {
                this.tab = newTab;
            },
            getEmpDetails() {
                this.getBaseURL = global[0].IMAGE_URL;
                this.$Progress.start();
                if(this.currentEmployeeID) {
                    service.get('employee/' + this.currentEmployeeID, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then((res) => {
                            this.detailEmployee = res.data.result;
                            setTimeout(()=>{
                                CKEDITOR.replace( 'editor1' );
                            }, 2000);
                            //console.log(res);
                        }).catch((err) => {
                            console.log(err);
                        });
                }
            }
        },
        beforeMount() {
            this.getEmpDetails();

            bus.$on('onUpdateOrAdd', (data) => {
                //this.personalInfo = data;
                //console.log("Emit fire..", data);
                this.getEmpDetails();
            });
        },

    }

</script>
<style scoped>


</style>
